import React, { useCallback, useState } from 'react';
import { actions } from '@ecosystem/newron-design-system';

interface MobileChartButtonProps {
  chartFullscreen: boolean;
  setChartFullscreen: React.Dispatch<React.SetStateAction<boolean>>;
}

const { IconButton } = actions;

export const useMobileChart = () => {
  const [chartFullscreen, setChartFullscreen] = useState(false);

  function MobileChartButton({ chartFullscreen, setChartFullscreen }: Readonly<MobileChartButtonProps>) {
    const expandFullscreen = useCallback(async () => {
      setChartFullscreen(true);
      if (window.screen.orientation && typeof (window.screen.orientation as any).lock === 'function') {
        try {
          await document.documentElement.requestFullscreen();
          await (window.screen.orientation as any).lock('landscape');
        } catch (_) {
          return;
        }
      }
    }, [setChartFullscreen]);

    const exitFullscreen = useCallback(() => {
      setChartFullscreen(false);
      if (window.screen.orientation && typeof (window.screen.orientation as any).unlock === 'function') {
        document.exitFullscreen().then(() => {
          (window.screen.orientation as any).unlock();
        });
      }
    }, [setChartFullscreen]);

    return (
      <div className="absolute z-10 p-2">
        {chartFullscreen ? (
          <IconButton size="md" color="brand" onClick={exitFullscreen} testId="exit-fullscreen-button">
            <IconButton.icons.Collapse />
          </IconButton>
        ) : (
          <IconButton size="md" color="brand" onClick={expandFullscreen} testId="expand-fullscreen-button">
            <IconButton.icons.Expand />
          </IconButton>
        )}
      </div>
    );
  }
  return { chartFullscreen, setChartFullscreen, MobileChartButton };
};
